import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import tablesData from "../../../../Data/Tables/Accounting/ClosingBalances/tables";
import headersData from "../../../../Data/Tables/Accounting/ClosingBalances/headers";
import toast from "react-hot-toast";
import ActionButton from "../../../../Componets/Buttons/action";
import Status from "../../../../Componets/Status";
import Loadercomponent from "../../../../Componets/Loader";
import {
  get_all_closing_balances,
  toggle_period_lock,
} from "../../../../Controllers/Accounting/ClosingBalances";
import ClosingBalanceForm from "../Form";

const ClosingBalanceTable = () => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState([]);
  const [header, setHeader] = useState(headersData);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });


  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      start_date: headerdata?.start_date,
      end_date: headerdata?.end_date,
    });
  };

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData();
  };

  const handleToggleLock = async (id, currentLockStatus) => {
    try {
      const response = await toggle_period_lock({
        balance_id: id,
        is_locked: !currentLockStatus,
      });

      if (response?.status) {
        toast.success(response?.message);
        fetchData();
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      toast.error("Failed to toggle lock status");
    }
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        start_date: tabledata?.start_date,
        end_date: tabledata?.end_date,
        page: tabledata?.page || 1,
        limit: tabledata?.limit || 10,
      };

      const response = await get_all_closing_balances(data);

      if (response?.status) {
        let tableData = [];

        response?.data?.data?.map((balance, index) => {
          tableData.push({
            Period: `${new Date(balance.period_start).toLocaleDateString()} - ${new Date(balance.period_end).toLocaleDateString()}`,
            Branch : `${balance.branch.name}`,
            "Opening Balance": `₹${balance.opening_balance.toLocaleString()}`,
            "Total Debit": `₹${balance.total_debit.toLocaleString()}`,
            "Total Credit": `₹${balance.total_credit.toLocaleString()}`,
            "Closing Balance": `₹${balance.closing_balance.toLocaleString()}`,
            Status: (
              <button
                onClick={() => handleToggleLock(balance._id, balance.is_locked)}
                className={`px-3 py-1 rounded-full text-sm ${
                  balance.is_locked
                    ? "bg-red-100 text-red-700"
                    : "bg-green-100 text-green-700"
                }`}
              >
                {balance.is_locked ? "Locked" : "Unlocked"}
              </button>
            ),
            Action: (
              <ActionButton
                edit={`/app/settings/closing-balance/edit/${balance._id}`}
                id={balance._id}
                api="delete-closing-balance"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setBody(tableData);
        setLoader(false);
      } else {
        toast.error(response?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast.error(errors?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
      fetchData();
    }, []);

  return (
    <>
      <Header
        headers={header}
        setHeaders={setHeader}
        formdata={formdata}
      >
        <Loadercomponent loader={loader}>
          <Table
            head={tablesData}
            body={body}
            pagination={pagination}
            paginationdata={paginationdata}
          />
        </Loadercomponent>
      </Header>
    </>
  );
};

export default ClosingBalanceTable;
